<template>
  <el-dialog
    title="修改密码"
    :visible="visible"
    center
    width="40%"
    @close="close"
    :modal-append-to-body="false"
  >
    <div class="form">
      <el-form
        ref="form"
        :col="2"
        :rules="rules"
        :model="formLabel"
        label-width="120px"
      >
        <!-- <el-form-item label="登录账号" prop="user" :spans="24">
                  <div>{{ userAcconut }}</div>
              </el-form-item> -->
        <el-form-item label="原密码" prop="code" :spans="24">
          <el-input
            type="password"
            maxlength="18"
            v-model.number="formLabel.code"
            placeholder="原密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpwd" :spans="24">
          <el-input
            type="password"
            maxlength="18"
            v-model.number="formLabel.newpwd"
            placeholder="密码长度为8-16位，必须同时包含数字,小写字母，大写字母，特殊字符"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newpassword1" :spans="24">
          <el-input
            type="password"
            maxlength="18"
            v-model.number="formLabel.newpassword1"
            placeholder="密码长度为8-16位，必须同时包含数字,小写字母，大写字母，特殊字符"
            show-password
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="输入验证码" prop="card">
                  <el-input maxlength="4" placeholder="验证码" v-model="formLabel.card" @keyup.enter.native="toAmend()">
                      <template slot="append">
                          <validate-code ref="validate-code" @change="_setCheckCode"></validate-code>
                      </template>
                  </el-input>
              </el-form-item> -->
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="button" type="primary" @click.native.prevent="toAmend">
        确 定
      </el-button>
      <el-button @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
// import validateCode from "@/views/login/ValidateCode";
// import securityUserRoom from "@/api/security/securityUserRoom";
import { modifyPasswordSelf } from "@/api/platform/account/accountInfo";
import { Encrypt } from "@/utils/crypto";
export default {
  // components: {
  //   validateCode,
  // },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新密码"));
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(
          new Error(
            "密码长度为8-16位，必须同时包含数字,小写字母，大写字母，特殊字符"
          )
        );
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formLabel.newpwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      //密钥
      token: sessionStorage.getItem("token"),
      userAcconut: sessionStorage.getItem("userAccount"),
      formLabel: {
        code: "", //原密码
        newpwd: "", //新密码
        newpassword1: "", //确认密码
        card: "", //验证码
        codeToken: "", //验证码token
      },
      rules: {
        mandatory: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        code: [
          {
            required: true,
            message: "请输入原密码",
            trigger: "blur",
          },
        ],
        newpwd: {
          required: true,
          trigger: "blur",
          validator: validatePass,
        },
        newpassword1: {
          required: true,
          trigger: "blur",
          validator: validatePass2,
        },
        card: {
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    // 获取验证码token
    _setCheckCode(value) {
      this.formLabel.codeToken = value;
    },
    // 确定修改密码
    toAmend() {
      const that = this;
      this.$refs.form.validate(async (valid) => {
        if (!valid) return this.$message.error("请填写必要信息");
        const params = {
          // code: this.formLabel.card,
          // codeToken: this.formLabel.codeToken,
          // pwd: Encrypt(JSON.stringify(this.formLabel.code)),
          oldPassword: Encrypt(this.formLabel.code),
          newPassword: Encrypt(this.formLabel.newpwd),
        };
        const res = await modifyPasswordSelf(params);
        if (res.code > 0) {
          this.close();
          this.$message.success("修改密码成功");
          //setTimeout(() => {
          //  sessionStorage.removeItem("token");
          //  that.$router.push("/login");
          //}, 3000);
        }
      });
    },
    // 关闭界面
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
// .button {
//     margin-left: 100px;
// }
.el-input-group__append {
  .validate-code {
    height: 26px;
  }
}
.el-input-group--append {
  ::v-deep .el-input-group__append {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/platform/account/modify/index.vue